import { useNavigate } from "react-router-dom";

const partners = [
    {
      name: "Abu Dhabi Police",
      logo: "/ab1.png",
    },
    {
      name: "Abu Dhabi Agriculture and Food Safety Authority",
      logo: "/ab2.png",
    },
    {
      name: "Khalifa Bin Zayed Al Nahyan Foundation",
      logo: "/ab3.png",
    },
    {
      name: "Tadweer Group",
      logo: "/ab4.png",
    },
  ];
  
  export default function PartnersGrid() {
   
    const navigate = useNavigate()
    return (
      <div className="px-6 py-12 text-center bg-[#FFE095]">
        <h2 className="mb-4 text-3xl font-semibold text-white">PARTNERS</h2>
        <div className="grid justify-center grid-cols-2 gap-6 md:grid-cols-4">
          {partners.map((partner, i) => (
            <div
              key={i}
              className="flex flex-col items-center p-6 bg-white rounded-lg shadow-md"
            >
              <img src={partner.logo} alt={partner.name} className="h-20 mb-4" />
              <p className="text-sm font-semibold text-center">{partner.name}</p>
            </div>
          ))}
        </div>
      </div>
    );
  }